import { render, staticRenderFns } from "./externalPenyakitRanap.vue?vue&type=template&id=6edbf4ea"
import script from "./externalPenyakitRanap.vue?vue&type=script&lang=js"
export * from "./externalPenyakitRanap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6edbf4ea')) {
      api.createRecord('6edbf4ea', component.options)
    } else {
      api.reload('6edbf4ea', component.options)
    }
    module.hot.accept("./externalPenyakitRanap.vue?vue&type=template&id=6edbf4ea", function () {
      api.rerender('6edbf4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/external/pelayanan/externalPenyakitRanap.vue"
export default component.exports